<script lang="ts">
  import Spinner from "@shared/svelte/Components/Spinner.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import FizzStyles from "@shared/svelte/Components/FizzStyles.svelte";
  import { params } from "@roxi/routify";

  let loading: boolean = true;
  $: mobile = false;

  const setDesktop = () => {
    mobile = false;
  };

  const setMobile = () => {
    mobile = true;
  };

  const iframeLoad = () => {
    loading = false;
  };
</script>

<FizzStyles>
  <nav class="fizz-subnav" style="margin-top:50px">
    <div class="fizz-grid-equal-columns" style="--grid-columns: 3; --grid-col-min: 200px;">
      <h2 class="fizz-heading-4">Preview Mode</h2>

      <div class="fizz-flex-row-4 fizz-hide-on-small">
        <button class="fizz-icon-button cursor-pointer" id="desktop">
          <Icon onPress={setDesktop} type="Desktop" extraClassNames="fizz-icon-24"></Icon>
        </button>
        <button class="fizz-icon-button cursor-pointer" id="mobile">
          <Icon onPress={setMobile} type="Mobile" extraClassNames="fizz-icon-24"></Icon>
        </button>
      </div>

      <span class="fizz-text-brand">
        <Icon
          onPress={() => window.history.back()}
          type="X"
          extraClassNames="fizz-icon-16 cursor-pointer"
        ></Icon>
      </span>
    </div>
  </nav>
  <div class="fizz-layout-storefront">
    <main class="fizz-grid-row-full" data-grid-area="main">
      {#if loading}
        <Spinner></Spinner>
      {/if}
      <iframe
        src={`/distributor/storefronts/preview_content/${$params.distributorId}`}
        title="preview"
        class="fizz-iframe {mobile ? 'fizz-iframe-small' : ''}"
        id="storefront-preview-content"
        on:load={iframeLoad}
      />
    </main>
  </div>
</FizzStyles>
